import { connect } from 'react-redux'
import { setSubmitSucceeded } from 'redux-form'
import { compose, withHandlers } from 'recompose'
import { sendServicesAndDateTime } from '../actions'
import { APPOINTMENT_FORM_NAME } from 'constant'
import AppointmentButton from './Button'

export default compose(
  connect(null, { sendServicesAndDateTime, setSubmitSucceeded }),
  withHandlers({
    onClickHandler: ({ sendServicesAndDateTime, setSubmitSucceeded, isFromOnlineAppointment }) => () => {
      setSubmitSucceeded(APPOINTMENT_FORM_NAME)
      sendServicesAndDateTime(isFromOnlineAppointment)
    }
  })
)(AppointmentButton)
